module.exports = __webpack_public_path__ + "bc603c2905b82c1cc1ccc36afb9c7e5e.pdf";